import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { validatePermission } from '../../../../../../utils/services/validatePermission'
import CustomModal from '../../../../../components/Modals/CustomModal'
import LIModalForm from './IncidentModalForm'
import RotatingLinesLoader from '../../../../../components/_shared/Loaders/RotatingLinesLoader'

const IncidentFilteredModal = ({
    handlModalClose,
    show,
    isLoading,
    setIsOpen,
    handlefilteredData,
    filteredData,
    setClearBtn,
    refStatusOption,
    isLoadingRefStatus,
}) => {
    const location = useLocation()
    const moduleName = location.pathname.startsWith('/myincidents')
        ? 'myincidents'
        : 'incidents'

    const permissions = useSelector((state) => state.auth.permissions)
    const showNoUser = validatePermission(permissions, moduleName, 'get_unassigned_incidents')

    return (
        <CustomModal isChange={true} size={'lg'} onHide={handlModalClose} show={show} text={`Filter`}>
            {isLoadingRefStatus ? (
                <RotatingLinesLoader />
            ) : (
                <LIModalForm
                    handlModalClose={handlModalClose}
                    show={show}
                    isLoading={isLoading}
                    setIsOpen={setIsOpen}
                    handlefilteredData={handlefilteredData}
                    filteredData={filteredData}
                    setClearBtn={setClearBtn}
                    refStatusOption={refStatusOption}
                    showNoUser={showNoUser}
                />
            )}
        </CustomModal>
    )
}

export default IncidentFilteredModal
